/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-13 18:04:29
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——moreExting组件
 * @url:www.picoxr.com/cn/about
 */
import styles from "../../index.module.scss";
import React from "react";
import { IconRight } from "@arco-design/web-react/icon"; //右箭头icon

interface IProps {
  words: Record<string, string>;
  ctry: string;
}
const MoreExting: React.FC<IProps> = ({ words, ctry }) => {
  return (
    <div className={styles["more-exciting-warp"]}>
      <h2>{words?.about_us_more_exciting}</h2>
      <div className={styles["content"]}>
        <div className={`${styles["item1-warp"]} ${styles["item-warp"]}`}>
          <div className={styles["item"]}>
            <div className={styles["title"]}>
              {words?.about_us_more_exciting_title1}
            </div>
            <div className={styles["text"]}>{words?.about_us_more_text1}</div>
            <div className={styles["learn-more"]}>
              <a
                href="https://www.example.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {words?.common_learn_more}
              </a>
              <IconRight />
            </div>
          </div>
        </div>
        <div className={`${styles["item2-warp"]} ${styles["item-warp"]}`}>
          <div className={styles["item"]}>
            <div className={styles["title"]}>
              {words?.about_us_more_exciting_title2}
            </div>
            <div className={styles["text"]}>{words?.about_us_more_text2}</div>
            <div className={styles["learn-more"]}>
              <a
                href="https://developer-global.pico-interactive.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {words?.common_learn_more}
              </a>
              <IconRight />
            </div>
          </div>
        </div>
        <div className={`${styles["item3-warp"]} ${styles["item-warp"]}`}>
          <div className={styles["item"]}>
            <div className={styles["title"]}>
              {words?.about_us_more_exciting_title3}
            </div>
            <div className={styles["text"]}>{words?.about_us_more_text3}</div>
            <div className={styles["learn-more"]}>
              <a href={`/${ctry}/newsroom`}>{words?.common_learn_more}</a>
              <IconRight />
            </div>
          </div>
        </div>
        <div className={`${styles["item4-warp"]} ${styles["item-warp"]}`}>
          <div className={styles["item"]}>
            <div className={styles["title"]}>
              {words?.about_us_more_exciting_title4}
            </div>
            <div className={styles["text"]}>{words?.about_us_more_text4}</div>
            <div className={styles["learn-more"]}>
              <a href={`/${ctry}/blog`}>{words?.common_learn_more}</a>
              <IconRight />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreExting;
